import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { MotionConfig } from "framer-motion";
import { Nav } from "@/components/site/Nav";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Commodities } from "@/components/site/Commodities";
import { Verification } from "@/components/site/Verification";
import { Logistics } from "@/components/site/Logistics";
import { Insights } from "@/components/site/Insights";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import InsightArticle from "@/pages/InsightArticle";
import LegalPage from "@/pages/LegalPage";
import CommodityDetail from "@/pages/CommodityDetail";
import Process from "@/pages/Process";
import Compliance from "@/pages/Compliance";
import Mandate from "@/pages/Mandate";
import MandateSuccess from "@/pages/MandateSuccess";
import AboutPage from "@/pages/About";
import Desk from "@/pages/Desk";
import InsightsIndex from "@/pages/InsightsIndex";
import DoreTool from "@/pages/DoreTool";
import French from "@/pages/French";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -96 });
        else el.scrollIntoView({ behavior: "smooth" });
      }, 80);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Home = () => (
  <div>
    <Hero />
    <Marquee />
    <Manifesto />
    <About />
    <Commodities />
    <Verification />
    <Logistics />
    <Insights />
    <Contact />
  </div>
);

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <ScrollManager />
        <SmoothScroll />
        <Toaster theme="dark" position="bottom-right" />
        <div className="bg-[#0A0A0B] min-h-screen">
          <a href="#content" className="skip-link" data-testid="skip-link">Skip to content</a>
          <Nav />
          <main id="content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/process" element={<Process />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/mandate" element={<Mandate />} />
              <Route path="/mandate/success" element={<MandateSuccess />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/insights" element={<InsightsIndex />} />
              <Route path="/insights/:slug" element={<InsightArticle />} />
              <Route path="/tools/dore-calculator" element={<DoreTool />} />
              <Route path="/fr" element={<French />} />
              <Route path="/desk" element={<Desk />} />
              <Route path="/commodities/:slug" element={<CommodityDetail />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
